import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, isNil } from 'lodash'
import LabeledTextField from '../common/LabeledTextField'
import RemoteOptionsSelectField from '../common/RemoteOptionsSelectField'
import SelectField from '../common/SelectField'
import SubmitButton from '../common/SubmitButton'

class CarrierUserForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object,
    carrierBrands: PropTypes.array,
    indexCarrierBrands: PropTypes.func.isRequired,
    resetCarrierBrands: PropTypes.func.isRequired,
    carrierBrandsRequestInProgress: PropTypes.bool.isRequired,
    platforms: PropTypes.array,
    indexPlatforms: PropTypes.func.isRequired,
    resetPlatforms: PropTypes.func.isRequired,
    platformsRequestInProgress: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    requestInProgress: PropTypes.bool.isRequired,
    submitLabel: PropTypes.string
  }

  static defaultProps = {
    submitLabel: 'Send Invite'
  }

  constructor(props) {
    super(props)

    const initialValues = cloneDeep(props.initialValues)

    this.state = {
      values: initialValues
    }
  }

  handleBlur = (field) => {
  }

  handleChange = (field, value) => {
    this.setState((prevState) => {
      const newState = prevState.values

      if (isNil(value) || value === '') {
        newState[field] = null
      } else {
        newState[field] = value
      }

      return { values: newState }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.props.handleSubmit(this.state.values)
  }

  render() {
    const { errors } = this.props

    return (
      <form className="pure-form pure-form-stacked" onSubmit={this.handleSubmit}>
        <fieldset>
          <LabeledTextField
            key="username"
            name="username"
            label="Username"
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            errorMessage={errors.username}
            value={this.state.values.username}
          />
          <LabeledTextField
            key="email"
            name="email"
            label="Email"
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            errorMessage={errors.email}
            value={this.state.values.email}
          />
          <RemoteOptionsSelectField
            placeholder="Type at least 2 characters to search"
            key="carrier_brands"
            name="carrier_brands"
            label="Carrier Brands"
            recordLabel={['name']}
            handleChange={this.handleChange}
            records={this.props.carrierBrands}
            requestInProgress={this.props.carrierBrandsRequestInProgress}
            reset={this.props.resetCarrierBrands}
            recordsRequest={this.props.indexCarrierBrands}
            value={this.state.values.carrier_brands}
            multi
          />
        </fieldset>

        <fieldset>
          <SelectField
            key="carrier_verification_tool"
            name="carrier_verification_tool"
            label="Carrier Verification Tool"
            options={[{ value: true, text: 'Yes' }, { value: false, text: 'No' }]}
            handleChange={this.handleChange}
            errorMessage={errors.carrier_verification_tool}
            value={this.state.values.carrier_verification_tool}
            disabled={false}
          />
          <RemoteOptionsSelectField
            placeholder="Type at least 2 characters to search"
            key="cvt_platforms"
            name="cvt_platforms"
            label="CVT Available Quoting Platforms"
            recordLabel={['name']}
            recordValue="name"
            handleChange={this.handleChange}
            records={this.props.platforms}
            requestInProgress={this.props.platformsRequestInProgress}
            reset={this.props.resetPlatforms}
            recordsRequest={this.props.indexPlatforms}
            value={this.state.values.cvt_platforms}
            multi
          />
          <SelectField
            key="quote_reporting"
            name="quote_reporting"
            label="Quote Reporting"
            options={[{ value: true, text: 'Yes' }, { value: false, text: 'No' }]}
            handleChange={this.handleChange}
            errorMessage={errors.quote_reporting}
            value={this.state.values.quote_reporting}
            disabled={false}
          />
          <SelectField
            key="analytics_reporting"
            name="analytics_reporting"
            label="Analytics Reporting"
            options={[{ value: true, text: 'Yes' }, { value: false, text: 'No' }]}
            handleChange={this.handleChange}
            errorMessage={errors.analytics_reporting}
            value={this.state.values.analytics_reporting}
            disabled={false}
          />
        </fieldset>

        <fieldset>
          <SubmitButton
            title={this.props.submitLabel}
            text={this.props.submitLabel}
            loading={this.props.requestInProgress}
          />
        </fieldset>
      </form>
    )
  }
}

export default CarrierUserForm
